module.exports = __webpack_public_path__ + "img/bfy-logo.af37ff31.svg";